import { normalizeText } from './normalize.js';
/** Hash'lenecek anahtar metin: normalize edilmiş yer parçaları + kayıt no, '|' ile. hash_version=1 kuralı. */
export function buildKeyText(placeParts, registryNo) {
    const parts = placeParts.map(normalizeText).filter((p) => p.length > 0);
    return [...parts, normalizeText(registryNo)].join('|');
}
//# sourceMappingURL=key-text.js.map